<template>
  <div class="container-lg">
    <h1 class="page-header">Materials</h1>

    <DbTableControl :buttons="buttons"></DbTableControl>

    <div class="table table-responsive table-sm">
      <table class="table">
        <thead>
          <tr>
            <th>SKU</th>
            <th>Type</th>
            <th>Name</th>
            <th>Cost</th>
            <th>Unit</th>
            <th>Colour</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="i in items" :key="i.id">
            <td class="text-nowrap">
              <router-link class="d-block" :to="'/material/' + i.id">{{
                i.sku
              }}</router-link>
            </td>
            <td>
              {{ i.type_name }}
            </td>
            <td>
              {{ i.name }}
            </td>
            <td align="right">
              {{ i.cost | currency}}
            </td>
            <td>
              {{ i.unit_name }}
            </td>
            <td>
              {{ i.color }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr v-show="showMore">
            <td colspan="8">
              <button class="btn btn-info" @click="handleMore()">
                Load more...
              </button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import { createWhereTextSearch } from "../lib/sql.js";
import { authFetch } from "../lib/auth.js";
import dbTableMixin from "../lib/dbtable-mixin";
import DbTableControl from "../components/DbTableControl";

export default {
  mixins: [dbTableMixin],
  components: {
    DbTableControl,
  },
  data() {
    return {
      buttons: [
        {
          to: "/material",
          text: "Add material",
          fa: "building",
          accesskey: "a",
        },
      ],
      items: [],
      limit: 25,
      offset: 0,
      showMore: false,
    };
  },
  methods: {
    handleMore() {
      this.offset += this.limit;
      this.load();
    },
    load() {
      let whereArray = [];
      if (this.searchtext) {
        whereArray.push(
          encodeURIComponent(
            createWhereTextSearch(this.searchtext, [
              "sku",
              "name",
              "type_name",
            ])
          )
        );
      }
      let where = "";
      if (whereArray.length > 0) {
        where += whereArray.join(" AND ");
      }
      authFetch(
        `/db/material_view?sort=name&limit=${this.limit + 1}&offset=${
          this.offset
        }` + (where ? "&where=" + where : "")
      )
        .then((resp) => resp.json())
        .then((newItems) => {
          this.showMore = false;
          if (newItems.length > this.limit) {
            this.showMore = true;
            newItems.pop();
          }
          if (this.offset === 0) {
            this.items = newItems;
          } else {
            this.items = this.items.concat(newItems);
          }
        });
    },
  },
};
</script>